module.exports = __webpack_public_path__ + "img/Transactions.d644c040.svg";